import React from 'react';
import Layout from './Layout';

const PrivacyPolicy = () => {
  return (
    <Layout>
      <div className="legal-page">
        <div className="legal-hero">
          <h1 className="legal-title">Privacy Policy</h1>
          <p className="legal-subtitle">Last Updated: November 16, 2025</p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>Our Commitment to Privacy</h2>
            <p>
              At WestBay Group, we're not here to sell your data or spam you with garbage. 
              We're here to build real solutions, and that means respecting your privacy. 
              This isn't your typical legal mumbo-jumbo - we're going to tell you exactly 
              what we collect, why we collect it, and what we do with it. No corporate BS.
            </p>
          </section>

          <section className="legal-section">
            <h2>1. Information We Collect</h2>
            
            <h3>Information You Give Us</h3>
            <ul>
              <li><strong>Contact Form:</strong> Name, email, company name, and your message when you reach out to us</li>
              <li><strong>Newsletter:</strong> Email address if you subscribe to our updates</li>
              <li><strong>Demo Requests:</strong> Contact information and company details for investor presentations</li>
            </ul>

            <h3>Information We Collect Automatically</h3>
            <ul>
              <li><strong>Usage Data:</strong> Pages visited, time spent, links clicked</li>
              <li><strong>Device Info:</strong> Browser type, operating system, IP address</li>
              <li><strong>Cookies:</strong> Small data files to remember preferences and analyze traffic</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>2. How We Use Your Information</h2>
            <p>We use your information to:</p>
            <ul>
              <li>Respond to your inquiries and provide customer support</li>
              <li>Send you updates about Poser AI™ and WestBay Group (only if you opt-in)</li>
              <li>Improve our website and services</li>
              <li>Analyze usage patterns and optimize user experience</li>
              <li>Comply with legal obligations</li>
            </ul>
            <p><strong>What we DON'T do:</strong></p>
            <ul>
              <li>❌ Sell your data to third parties</li>
              <li>❌ Spam you with irrelevant marketing</li>
              <li>❌ Share your info without your permission (except as legally required)</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>3. Data Storage & Security</h2>
            <p>
              Your data is stored securely using industry-standard practices:
            </p>
            <ul>
              <li>MongoDB database with encryption at rest</li>
              <li>AWS infrastructure with multi-region redundancy</li>
              <li>SSL/TLS encryption for data in transit</li>
              <li>Regular security audits and monitoring</li>
              <li>Access controls and authentication for all systems</li>
            </ul>
            <p>
              We're a veteran-owned company run by a guy with 30+ years in cloud security. 
              We take this stuff seriously.
            </p>
          </section>

          <section className="legal-section">
            <h2>4. Cookies & Tracking</h2>
            <p>We use cookies for:</p>
            <ul>
              <li><strong>Essential Cookies:</strong> Required for the site to function (login sessions, preferences)</li>
              <li><strong>Analytics Cookies:</strong> To understand how visitors use our site</li>
              <li><strong>Marketing Cookies:</strong> To measure effectiveness of our content</li>
            </ul>
            <p>
              You can disable cookies in your browser settings, but some features may not work properly.
            </p>
          </section>

          <section className="legal-section">
            <h2>5. Third-Party Services</h2>
            <p>We may use third-party services that collect information:</p>
            <ul>
              <li><strong>AWS (Amazon Web Services):</strong> Hosting and infrastructure</li>
              <li><strong>Google Analytics:</strong> Website traffic analysis (if implemented)</li>
              <li><strong>Email Service Providers:</strong> For newsletter delivery</li>
            </ul>
            <p>
              These services have their own privacy policies. We choose vendors who respect privacy 
              and comply with regulations.
            </p>
          </section>

          <section className="legal-section">
            <h2>6. Your Rights</h2>
            <p>You have the right to:</p>
            <ul>
              <li><strong>Access:</strong> Request a copy of your personal data</li>
              <li><strong>Correction:</strong> Update or correct inaccurate information</li>
              <li><strong>Deletion:</strong> Request deletion of your data (subject to legal requirements)</li>
              <li><strong>Opt-Out:</strong> Unsubscribe from marketing communications at any time</li>
              <li><strong>Data Portability:</strong> Request your data in a machine-readable format</li>
            </ul>
            <p>
              To exercise these rights, email us at <strong>privacy@westbay.io</strong>
            </p>
          </section>

          <section className="legal-section">
            <h2>7. Children's Privacy</h2>
            <p>
              Our services are not directed to individuals under 18. We do not knowingly collect 
              personal information from children. If you believe we've inadvertently collected 
              such information, contact us immediately and we'll delete it.
            </p>
          </section>

          <section className="legal-section">
            <h2>8. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. When we do, we'll update the 
              "Last Updated" date at the top. Significant changes will be announced on our website. 
              Continued use of our services after changes constitutes acceptance of the updated policy.
            </p>
          </section>

          <section className="legal-section">
            <h2>9. Contact Us</h2>
            <p>
              Questions about this Privacy Policy? Want to exercise your rights? Just want to talk about privacy?
            </p>
            <ul>
              <li><strong>Email:</strong> privacy@westbay.io</li>
              <li><strong>General Inquiries:</strong> jim@westbay.io</li>
              <li><strong>Mail:</strong> WestBay Group, [Your Address]</li>
            </ul>
          </section>

          <div className="legal-footer">
            <p>
              <strong>Real Talk:</strong> We're a small, veteran-owned startup. We're not some faceless 
              corporation. If you have concerns about your privacy, reach out. We're real people who 
              actually read and respond to emails.
            </p>
            <p>🦅 Built with Philly Grit by WestBay Group</p>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default PrivacyPolicy;
